<template>
    <layout-basic>
        <section class="banner-text padding-bottom feature">
            <v-row no-gutters>
                <v-col class="banner-wrapper">
                    <!-- Shape Background -->
                    <div class="why-improve-shape-background">
                        <img class="why-improve-background-image border-bottom" :src="getImageSource(
                            'improve-hr-integrations-background.png',
                            'hr-integration/banner'
                        )
                            " />
                    </div>
                    <v-container class="banner-img-text-wrapper pb-0">
                        <!-- Banner Left Wrapper -->
                        <div class="banner-left-wrapper">
                            <div id="main-banner-wrapper">
                                <img class="hr-feature-rounded-rectangle-image" :src="getImageSource(
                                    'rounded-rectangle-green.png',
                                    'features/banner'
                                )
                                    " />
                                <div class="banner-text-overlay">
                                    SIMPLIFYING USER MANAGEMENT
                                </div>
                            </div>
                            <div class="banner-main-title">
                                HR App Integrations
                            </div>
                            <div class="banner-sub-text feature-banner-sub-text">
                                Sync users from some of the leading HR apps directly through the front end of IMPROVE,
                                simplifying user management.
                            </div>
                            <a id="request-demo-btn" href="/watch-demo"
                                class="request-demo-btn hr-integration mt-8 d-flex align-self-center">
                                Watch the 5-minute demo
                            </a>
                        </div>

                        <img class="hr-integration-image" :src="getImageSource(
                            'improve-hr-integration.png',
                            'hr-integration/banner'
                        )" />

                    </v-container>
                </v-col>
            </v-row>
        </section>
        <section style="margin-top: 80px;">
            <v-row no-gutters>
                <v-col cols="12" align-self="center">
                    <v-container>
                        <div class="hr-integration-title text-center">
                            <h2>HR Platform Integrations</h2>

                            <span>IMPROVE currently integrates with the following HR apps...</span>
                        </div>
                        <v-col cols="12" md="12" p>
                            <div class="logo-grid">
                                <a href="https://sense.hr/" class="logo-item" target="_blank">
                                    <img src="/static/hr-integration/improve-and-sense-hr.png" alt="Sense HR">
                                </a>
                                <a href="https://www.breathehr.com/en-gb/" class="logo-item" target="_blank">
                                    <img src="/static/hr-integration/improve-and-breathe-hr.png" alt="Breathe">
                                </a>
                                <a href="https://www.sage.com/en-gb/sage-business-cloud/hr/" class="logo-item" target="_blank">
                                    <img src="/static/hr-integration/improve-and-sage-hr.png" alt="Sage">
                                </a>
                                <a href="https://www.peoplehr.com/en-gb/" class="logo-item" target="_blank">
                                    <img src="/static/hr-integration/improve-and-people-hr.png" alt="People">
                                </a>
                                <a href="https://www.bamboohr.com/homepage-customer" class="logo-item" target="_blank">
                                    <img src="/static/hr-integration/improve-bamboohr-integration.png" alt="Bamboohr">
                                </a>
                                 <a href="https://www.iris.co.uk/products/staffology-hr/" class="logo-item" target="_blank">
                                    <img src="/static/hr-integration/improve-and-iris.png" alt="Iris">
                                </a>
                            </div>
                        </v-col>
                    </v-container>
                </v-col>
            </v-row>
            <v-row no-gutters class="pt-10">
                <v-col cols="12" align-self="center" no-gutters>
                    <v-container style="padding: 0 15px;">
                        <div class="hr-integration-wrapper">
                            <div class="hr-integration-content">
                                <h1>Sync Your Users</h1>

                                <span>Simplify your user management process.</span>

                                <p>
                                    Ensure <b>user information</b> is <b>always up-to-date</b>, reducing the need for manual data entry.
                                </p>    
                                <p>
                                    Enjoy a <b>more efficient onboarding process</b>, allocate <b>new staff</b> to <b>relevant playlists</b> to get them up-to-speed with <b>policies and procedures</b>.
                                </p>

                            </div>
                            <img class="hr-integration-platform-image" :src="getImageSource(
                                'integrate-users-from-hr-platforms-with-improve.png',
                                'hr-integration/integration'
                                )"/>
                        </div>
                    </v-container>
                </v-col>
            </v-row>
        </section>
        <section class="animate-cat-on-scroll">
            <v-row no-gutters>
                <v-col no-gutters>
                    <!-- Shape Background -->
                    <div class="demo-background">
                        <img class="demo-background-image" :src="
                    getImageSource(
                    'business-training-solution-free-trial.jpg',
                    'why-improve/demo'
                    )
                " />
                        <img class="demo-background-cat" :src="
                    getImageSource(
                    'training-courses-for-smes-with-improve.png',
                    'homepage/demo'
                    )
                " />
                        <div class="demo-content">
                            <h2 style="color: #ffffff !important;">Experience IMPROVE</h2>
                            <p style="color: #E7F8FF !important;">
                                Learn more about IMPROVE’s features and how they can enhance staff <br /> training for
                                your business.
                            </p>
                            <a :href="experienceHref" class="book-demo-btn" rel="noopener">
                                Experience IMPROVE
                            </a>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </section>
    </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
import { screensize } from '../../utils/screensize';
import { IMPROVE_CONFIG } from '@/config.js';
import { getExperienceHref } from '@/config/ctas';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
    name: "HRIntegration",
    metaInfo() {
        return {
            title: "IMPROVE HR Integrations: Simplify User Management with Leading HR Platforms",
            meta: [
                // Meta Description
                { name: 'description', content: "Streamline user management with IMPROVE's HR integrations. Sync staff data seamlessly from leading HR platforms like Sense HR, Breathe, Sage HR, and People HR." },
                
                // Keywords
                { name: 'keywords', content: "IMPROVE HR integrations, user management, HR platform integration, Sense HR, Breathe HR, Sage HR, People HR, employee onboarding, automated user sync"  },
                
                // Open Graph / Facebook Tags
                { property: 'og:title', content: "IMPROVE HR Integrations: Simplify User Management with Leading HR Platforms" },
                { property: 'og:description', content: "Connect your HR system with IMPROVE to simplify user management. Seamlessly sync staff data and streamline onboarding with integrations for Sense HR, Breathe HR, Sage HR, and People HR." },
                { property: 'og:image', content: "https://www.improve.online/static/SEO.png" },
                { property: 'og:type', content: "website" },
                { property: 'og:url', content: "https://www.improve.online/hr-integrations" },
                
                // Twitter Tags
                { name: 'twitter:card', content: "summary_large_image" },
                { name: 'twitter:title', content: "IMPROVE HR Integrations: Simplify User Management with Leading HR Platforms" },
                { name: 'twitter:description', content: "Sync user data seamlessly from HR systems like Sense HR, Breathe HR, Sage HR, and People HR with IMPROVE's integrations. Simplify onboarding and save time today!" },
                { name: 'twitter:image', content: "https://www.improve.online/static/SEO.png" }
            ],
            link: [
                { rel: 'canonical', href: "https://www.improve.online/hr-integrations" 
                }
            ]
        };
    },
    components: {
        LayoutBasic
    },
    computed: {
        experienceHref() {
            return getExperienceHref();
        },
    },
    data() {
        return {
            screenSize: currentScreenSize,
            directUrl: IMPROVE_CONFIG.DIRECT_URL,
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        // Listen for scroll events
        window.addEventListener('scroll', this.handleScroll);
        // Initial check when the component mounts
        this.handleScroll();
    },
    methods: {
        // Method to handle screen size changes
        handleResize() {
            this.screenSize = getCurrentScreenSize();
        },
        // Method to dynamically generate the image source based on screen size
        getImageSource(imageName, filepath) {
            return `/static/${filepath}/${this.screenSize}/${imageName}`;
        },
        handleScroll() {
            const catElemet = this.$el.querySelector('.animate-cat-on-scroll');

            const catRect = catElemet.getBoundingClientRect();
            const catInViewport =
                catRect.top >= 0 &&
                catRect.left >= 0 &&
                catRect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
                catRect.right <=
                (window.innerWidth || document.documentElement.clientWidth);

            if (catInViewport) {
                catElemet.classList.add('animate');
            }
        },
    },
    beforeDestroy() {
        // Remove event listener when component is destroyed
        window.removeEventListener('resize', this.handleResize);

        // Remove event listener when component is destroyed
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>
